import * as React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';
import Paper from '@material-ui/core/Paper';
import { PropTypes } from 'prop-types';

// Parametros props
//items: opciones a elegir [{ key: 'TI', label: 'TI' },{ key: 'HP', label: 'HP'  }]

ChipsArray.propTypes = {
  items: PropTypes.array.isRequired
};

ChipsArray.defaultProps = {
  items: [{ key: 'TI', label: 'TI' }, { key: 'HP', label: 'HP' }]
}

const ListItem = withStyles((theme) => ({
  margin: theme.spacing(0.5),
}))('li');

const handleDelete = () => {

}

function ChipsArray(props) {
  return (
    <Paper sx={{ width: '100%', display: 'flex', justifyContent: 'center', flexWrap: 'wrap', listStyle: 'none', p: 0.5, m: 0 }} component="ul">
      {props.items.map((data) => {
        return (
          <ListItem key={data.key}>
            <Chip label={data.label} onDelete={handleDelete} variant="outlined" color="error" />
          </ListItem>
        );
      })}
    </Paper>
  );
}

export default React.memo(ChipsArray);
